export const TITLE = "Home";
export const APP_ROOT = "src/APP_ROOT";

export const LOGOUT = "src/APP_ROOT/LOGOUT";
export const LOGOUT_SUCCESS = "src/APP_ROOT/LOGOUT_SUCCESS";
export const LOGOUT_ERROR = "src/APP_ROOT/LOGOUT_ERROR";

export const UPDATE_CONFIG = "src/APP_ROOT/UPDATE_CONFIG";
export const UPDATE_AUTO_REFRESH_CONFIG =
  "src/APP_ROOT/UPDATE_AUTO_REFRESH_CONFIG";
